import { Col, Row, Typography } from "antd";
import React from "react";
import { Form } from "formik-antd";
import { Formik } from "formik";
import * as Yup from "yup";
import { FormikPassword, FormikSubmitButton } from "../FormItems/index";
import { CheckOutlined } from "@ant-design/icons";
import Feedback from "../Utilities/Feedback";
import * as userReducer from "../Redux/User/reducer";
import { connect } from "react-redux";

const initialValues = {
  newPassword: "",
  confirmPassword: "",
  resetPasswordToken: "",
};

const validationSchema = Yup.object().shape({
  newPassword: Yup.string()
    .min(8)
    .required("Password is required")
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
      "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character"
    ),
  confirmPassword: Yup.string().oneOf(
    [Yup.ref("newPassword"), null],
    "Passwords should match"
  ),
});

const ResetPassword = (props) => {
  const updatePassword = (formDetails) => {
    formDetails.resetPasswordToken = props.resetToken;
    props.resetPassword(formDetails);
  };
  return (
    <Col xs={{ span: 24 }} style={{ overflowX: "hidden" }}>
      {props.isPasswordUpdated ? (
        <Feedback
          status="success"
          icon={<CheckOutlined />}
          title="Password Changed Succesfully"
          subTitle=""
        ></Feedback>
      ) : (
        <Col
          xs={{ span: 20 }}
          sm={{ span: 14 }}
          md={{ span: 12 }}
          lg={{ span: 10 }}
          xl={{ span: 8 }}
          style={{ margin: "auto", marginTop: "12vh" }}
        >
          <Row>
            <Typography.Title level={4}>Reset Password</Typography.Title>
          </Row>
          <Row style={{ marginTop: "2vh" }}>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              validateOnMount
              onSubmit={(formDetails) => updatePassword(formDetails)}
            >
              {(formik) => {
                return (
                  <Form>
                    <Col
                      xs={{ span: 17 }}
                      sm={{ span: 20 }}
                      lg={{ span: 22 }}
                      xl={{ span: 24 }}
                    >
                      <FormikPassword
                        name="newPassword"
                        label="New Password"
                        icon={true}
                        suffix={true}
                      />
                    </Col>
                    <Col
                      xs={{ span: 17 }}
                      sm={{ span: 20 }}
                      lg={{ span: 22 }}
                      xl={{ span: 24 }}
                    >
                      <FormikPassword
                        name="confirmPassword"
                        label="Confirm Password"
                      ></FormikPassword>
                    </Col>
                    <Col
                      sm={{ span: 20 }}
                      xs={{ span: 17 }}
                      lg={{ span: 22 }}
                      xl={{ span: 24 }}
                    >
                      <FormikSubmitButton
                        disabled={!formik.isValid}
                        name="Reset Password"
                      />
                    </Col>
                  </Form>
                );
              }}
            </Formik>
          </Row>
        </Col>
      )}
    </Col>
  );
};

const mapToState = (state) => ({
  isPasswordUpdated: state.userStore.isPasswordUpdated,
});

const mapToReducer = (dispatch) => {
  return {
    resetPassword: (resetDetails) =>
      dispatch(userReducer.resetPassword(resetDetails)),
  };
};

export default connect(mapToState, mapToReducer)(ResetPassword);
